/**
 * Aligent FredHopper Autocomplete JS
 */
// eslint-disable-next-line import/no-dynamic-require
define(['jquery', 'handlebars', 'markjs', 'handlebars-helpers', 'handlebars-helper-x', 'domReady!'], ($, Handlebars) => {
    const FhAutocomplete = {
        /**
         * Auxiliary function to show Results
         */
        showResult(event) {
            if (FhAutocomplete.load.show) {
                $(FhAutocomplete.selectors.results).show();
                const winWidth = $(window).width();
                if (winWidth < 960) {
                    const slideOutOpen = $('.slideout-open').length;
                    if (slideOutOpen >= 1) {
                        $('#page_wrapper').addClass('search-suggest-menu-open');
                    }
                    $('.site-header__banner').show(); // Ensure mobile shows auto complete too
                }
            }
        },
        /**
         * Auxiliary function to hide Results
         */
        hideResults(event) {
            if (!$(event.target).is(FhAutocomplete.element)
             && !$(event.target).is($(FhAutocomplete.element).find('*'))) {
                $(FhAutocomplete.selectors.results).hide();
                const winWidth = $(window).width();
                if (winWidth < 960) {
                    const slideOutOpen = $('.search-suggest-menu-open').length;
                    if (slideOutOpen >= 1) {
                        $('#page_wrapper').removeClass('search-suggest-menu-open');
                    }
                    $('.site-header__banner').hide(); // Ensure mobile hides auto complete too
                }
            }
        },

        getResults(query) {
            // url encode space and convert `and` to `&` to work with all suggest types
            query = query.replace(/\band(?=[\s])/gi, '&');
            query = query.replace(new RegExp(' ', 'g'), '%20');
            const postData = {
                storeId: FhAutocomplete.load.storeId,
                search: query
            };
            FhAutocomplete.load.ajax = $.ajax({
                url: '/scripts/fh/suggestions.php',
                type: 'POST',
                data: postData,
                dataType: 'json',
                beforeSend() {
                    if (FhAutocomplete.load.ajax != null) {
                        FhAutocomplete.load.ajax.abort();
                    }
                },
                success(data) {
                    FhAutocomplete.query = query;
                    $(FhAutocomplete.selectors.results).empty();
                    FhAutocomplete.load.show = false;

                    $.each(data.suggestionGroups, (i, suggestionGroup) => {
                        const source = $(`#aligent_fredhopper-handlebars-autocomplete-${suggestionGroup.indexName}`).html();
                        if (source) {
                            const template = Handlebars.compile(source);
                            const html = template(suggestionGroup);
                            $(FhAutocomplete.selectors.results).append(html);
                        }
                        $(`${FhAutocomplete.selectors.results}-${suggestionGroup.indexName}`)
                            .unmark()
                            .mark(FhAutocomplete.query);

                        if (suggestionGroup.suggestions.length) {
                            FhAutocomplete.load.show = true;
                        }
                    });

                    FhAutocomplete.showResult(data.suggestionGroups);
                }
            });
        },

        onSearchInput(e) {
            const val = $(e.currentTarget).val();
            if (val.length >= 2) {
                FhAutocomplete.getResults(val);
            }
        }
    };

    return {
        aligentFredhopperAutocomplete(config, element) {
            // inject Wrapper into DOM
            FhAutocomplete.selectors = config.selectors;
            FhAutocomplete.load = config.load;
            FhAutocomplete.element = element;

            $(FhAutocomplete.element).html($(FhAutocomplete.selectors.wrapper).html());
            // clear results container
            $(FhAutocomplete.selectors.results).empty();

            $(document.body).on('keydown', FhAutocomplete.selectors.search, FhAutocomplete.onSearchInput);
            $(document.body).on('focus', FhAutocomplete.selectors.search, () => {
                if (!$(FhAutocomplete.selectors.results).is(':empty')) {
                    FhAutocomplete.showResult();
                }
            });
            $(document.body).on('click', FhAutocomplete.hideResults);
            $(document).trigger('autocompleteLoaded');
        }
    };
});
